import { makeStyles } from '@material-ui/core';
import type { Outcome } from './outcome';

// The same four colours as the home page's deployments card, so an outcome
// reads the same wherever the portal shows one.
const useStyles = makeStyles({
  pill: {
    display: 'inline-block',
    padding: '1px 8px',
    borderRadius: 10,
    fontSize: '0.72rem',
    fontWeight: 600,
    lineHeight: 1.6,
    whiteSpace: 'nowrap',
  },
  success: { background: 'rgba(46, 160, 67, 0.15)', color: '#2EA043' },
  failure: { background: 'rgba(248, 81, 73, 0.15)', color: '#F85149' },
  running: { background: 'rgba(31, 111, 235, 0.15)', color: '#1F6FEB' },
  neutral: { background: 'rgba(110, 118, 129, 0.15)', color: '#6E7681' },
});

/**
 * An outcome in words. Colour carries it too, but never alone: a pill that
 * were only green or red would say nothing to a reader who cannot tell them
 * apart, or to a screen reader.
 */
export const OutcomePill = ({ outcome }: { outcome: Outcome }) => {
  const classes = useStyles();
  const tone =
    outcome.kind === 'unknown' || outcome.kind === 'neutral'
      ? classes.neutral
      : classes[outcome.kind];
  return (
    <span className={`${classes.pill} ${tone}`} data-outcome={outcome.kind}>
      {outcome.label}
    </span>
  );
};
